module.exports = __webpack_public_path__ + "media/images/common/revision_btn_l-8b29c8032c29de222972d0483782fdc3.png";